import ContentfulSignupCta from '../reference-blocks/contentful-signup-cta'
import ContentfulTooltip from '../reference-blocks/contentful-tooltip'
import ContentfulAsset from '../reference-blocks/contentful-asset'
import ContentfulRtfImage from '../reference-blocks/contentful-rtf-image'
import ContentfulArbitraryEmbeddedCode from '../reference-blocks/contentful-arbitrary-embedded-code'
import ContentfulRecipe from '../reference-blocks/contentful-recipe'
import ContentfulWorkout from '../reference-blocks/contentful-workout'
import ContentfulNewsletterEmailCapture from '../reference-blocks/contentful-newsletter-email-capture'

import generateRTFComponent from '.'

const ArticlePageRTF = generateRTFComponent({
  ContentfulSignupCta,
  ContentfulTooltip,
  ContentfulAsset,
  ContentfulRtfImage,
  ContentfulArbitraryEmbeddedCode,
  ContentfulRecipe,
  ContentfulWorkout,
  ContentfulNewsletterEmailCapture,
})

export default ArticlePageRTF
